import React, { Suspense } from "react";
import { Spinner, Box } from "@chakra-ui/react";
import PropTypes from "prop-types";

const ModalSpinner = () => (
  <Box
    display="flex"
    justifyContent="center"
    alignItems="center"
    minHeight="200px"
    position="fixed"
    top="0"
    left="0"
    right="0"
    bottom="0"
    bg="blackAlpha.600"
    zIndex="modal"
  >
    <Box bg="white" p={8} borderRadius="md" display="flex" flexDirection="column" alignItems="center" gap={4}>
      <Spinner size="lg" color="blue.500" thickness="3px" />
      <span>Carregando...</span>
    </Box>
  </Box>
);

const LazyModalWrapper = ({ children }) => <Suspense fallback={<ModalSpinner />}>{children}</Suspense>;

LazyModalWrapper.propTypes = {
  children: PropTypes.node,
};

export default LazyModalWrapper;
